import { Controller } from "@hotwired/stimulus";

// `in_marketplace` implies `public`:
//   - turning marketplace ON forces public ON
//   - turning public OFF forces marketplace OFF
export default class extends Controller {
  static targets = ["publicSwitch", "marketplaceSwitch"];

  marketplaceChanged() {
    if (!this.hasPublicSwitchTarget || !this.hasMarketplaceSwitchTarget) return;

    if (this.marketplaceSwitchTarget.checked) {
      this.publicSwitchTarget.checked = true;
    }
  }

  publicChanged() {
    if (!this.hasPublicSwitchTarget || !this.hasMarketplaceSwitchTarget) return;

    if (!this.publicSwitchTarget.checked) {
      this.marketplaceSwitchTarget.checked = false;
    }
  }
}
